import Handlers from '../dispatcher/Handlers';
import { ActionTypes } from '../constants/CentricConstants';
import ContactApi from '../server/ContactApi';

export default {

    save: function(entity) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.CONTACT_SAVE, ActionTypes.FORM_SUBMIT_SUCCESS);
        
        return ContactApi.save(entity)
            .then(handleSuccess, Handlers._handleFormError)
            .catch(Handlers._handleException);
    },

    getAll: function(params) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.CONTACT_LIST);
        const handleError = Handlers.createErrorHandler(ActionTypes.CONTACT_LIST_ERROR);

        return ContactApi.getAll(params)
            .then(handleSuccess, handleError)
            .catch(Handlers._handleException);
    },

    getById: function(id) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.CONTACT_INFO);
        const handleError = Handlers.createErrorHandler(ActionTypes.CONTACT_INFO_ERROR);

        return ContactApi.getById(id)
            .then(handleSuccess, handleError)
            .catch(Handlers._handleException);
    },
  
    search: function(searchText, params) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.SEARCH_RESULT_RECEIVED, ActionTypes.CONTACT_LIST);
        const handleError = Handlers.createErrorHandler(ActionTypes.SEARCH_ERROR);
        
        return ContactApi.search(searchText, params)
            .then(handleSuccess, handleError);
    },

    update: function(id, entity) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.CONTACT_UPDATE, ActionTypes.FORM_SUBMIT_SUCCESS);
        
        return ContactApi.update(id, entity)
            .then(handleSuccess, Handlers._handleFormError)
            .catch(Handlers._handleException);
    },
    
    delete: function(id) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.CONTACT_DELETE);
        const handleError = Handlers.createErrorHandler(ActionTypes.CONTACT_DELETE_ERROR);
        
        return ContactApi.delete(id)
            .then(handleSuccess, handleError)
            .catch(Handlers._handleException);
    }

};
